import axios from 'axios';
import telegramBaseUrl from './telegram.server';

export const axiosTelegramInstance = axios.create({
  baseURL: telegramBaseUrl,
  headers: {
    Accept: '*/*',
    'Content-Type': 'application/json',
  },
});

axiosTelegramInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) config.headers['authorization'] = token;
    return config;
  },
  (error) => Promise.reject(error),
);

export default axiosTelegramInstance;
